import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { supabase } from "../supabaseClient";
import {
  ArrowLeft,
  Trash2,
  CheckCircle,
  XCircle,
  Calendar,
} from "lucide-react";

export default function DetailSiswa() {
  const { id } = useParams();
  const [siswa, setSiswa] = useState(null);
  const [tagihan, setTagihan] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newTagihan, setNewTagihan] = useState({ judul: "", jumlah: "" });

  useEffect(() => {
    ambilDataDetail();
  }, [id]);

  async function ambilDataDetail() {
    setLoading(true);
    // Ambil Info Siswa
    const { data: dataSiswa } = await supabase
      .from("siswa")
      .select("*")
      .eq("id", id)
      .single();

    // Ambil Tagihan (Urutkan yang terbaru di atas)
    const { data: dataTagihan } = await supabase
      .from("tagihan")
      .select("*")
      .eq("siswa_id", id)
      .order("id", { ascending: false });

    setSiswa(dataSiswa);
    setTagihan(dataTagihan || []);
    setLoading(false);
  }

  // --- FITUR 1: TAMBAH TAGIHAN ---
  async function handleAddTagihan(e) {
    e.preventDefault();
    if (!newTagihan.judul || !newTagihan.jumlah) return alert("Isi lengkap!");

    const { error } = await supabase.from("tagihan").insert([
      {
        siswa_id: id,
        judul_tagihan: newTagihan.judul,
        jumlah: newTagihan.jumlah,
        status: "BELUM_LUNAS",
        jatuh_tempo: new Date().toISOString(), // Default hari ini
        tanggal_bayar: null, // Awalnya kosong
      },
    ]);

    if (error) alert(error.message);
    else {
      setNewTagihan({ judul: "", jumlah: "" });
      ambilDataDetail();
    }
  }

  // --- FITUR 2: UBAH STATUS + CATAT TANGGAL BAYAR ---
  async function toggleStatus(item) {
    const akanLunas = item.status !== "LUNAS"; // Cek apakah mau jadi LUNAS?

    // Jika jadi LUNAS -> Simpan Tanggal & Jam sekarang
    // Jika jadi BELUM -> Kosongkan Tanggal (null)
    const updateData = {
      status: akanLunas ? "LUNAS" : "BELUM_LUNAS",
      tanggal_bayar: akanLunas ? new Date().toLocaleString("id-ID") : null,
    };

    const { error } = await supabase
      .from("tagihan")
      .update(updateData)
      .eq("id", item.id);

    if (error) alert("Gagal update");
    else ambilDataDetail();
  }

  async function handleDeleteTagihan(tagihanId) {
    if (confirm("Hapus tagihan ini?")) {
      await supabase.from("tagihan").delete().eq("id", tagihanId);
      ambilDataDetail();
    }
  }

  // Helper format tanggal agar cantik
  function formatTanggal(strTanggal) {
    if (!strTanggal) return "-";
    // Karena kita simpan string locale ID, bisa langsung tampilkan
    // Atau jika format ISO, kita convert dulu.
    return strTanggal;
  }

  if (loading) return <p style={{ padding: 20 }}>Memuat...</p>;
  if (!siswa) return <p style={{ padding: 20 }}>Siswa tidak ditemukan.</p>;

  return (
    <div
      style={{
        padding: "20px",
        maxWidth: "600px",
        margin: "0 auto",
        fontFamily: "sans-serif",
      }}
    >
      <Link
        to="/siswa"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "5px",
          textDecoration: "none",
          color: "#666",
          marginBottom: "20px",
        }}
      >
        <ArrowLeft size={16} /> Kembali ke Daftar Siswa
      </Link>

      <div
        style={{
          background: "white",
          padding: "20px",
          borderRadius: "10px",
          border: "1px solid #ddd",
          marginBottom: "20px",
        }}
      >
        <h2 style={{ margin: "0 0 5px 0", color: "#2c3e50" }}>
          {siswa.nama_lengkap}
        </h2>
        <p style={{ margin: 0, color: "#666" }}>
          Kelas: {siswa.kelas} | NIS: {siswa.nis || "-"}
        </p>
      </div>

      <div
        style={{
          background: "#f8f9fa",
          padding: "15px",
          borderRadius: "10px",
          marginBottom: "30px",
          border: "1px dashed #ccc",
        }}
      >
        <h4 style={{ marginTop: 0, marginBottom: "10px", color: "#555" }}>
          + Tagihan Baru
        </h4>
        <form
          onSubmit={handleAddTagihan}
          style={{ display: "flex", gap: "10px" }}
        >
          <input
            placeholder="Judul (ex: LKS Fisika)"
            value={newTagihan.judul}
            onChange={(e) =>
              setNewTagihan({ ...newTagihan, judul: e.target.value })
            }
            style={{
              flex: 2,
              padding: "8px",
              borderRadius: "5px",
              border: "1px solid #ccc",
            }}
            required
          />
          <input
            type="number"
            placeholder="Rp"
            value={newTagihan.jumlah}
            onChange={(e) =>
              setNewTagihan({ ...newTagihan, jumlah: e.target.value })
            }
            style={{
              flex: 1,
              padding: "8px",
              borderRadius: "5px",
              border: "1px solid #ccc",
            }}
            required
          />
          <button
            type="submit"
            style={{
              background: "#2196F3",
              color: "white",
              border: "none",
              padding: "8px 15px",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Simpan
          </button>
        </form>
      </div>

      <h3 style={{ borderBottom: "2px solid #eee", paddingBottom: "10px" }}>
        Riwayat Tagihan
      </h3>

      {tagihan.length === 0 ? (
        <p style={{ color: "#999" }}>Belum ada tagihan.</p>
      ) : (
        tagihan.map((item) => (
          <div
            key={item.id}
            style={{
              background: "white",
              padding: "15px",
              marginBottom: "10px",
              borderRadius: "8px",
              border: "1px solid #eee",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <div style={{ fontWeight: "bold", fontSize: "16px" }}>
                {item.judul_tagihan}
              </div>
              <div style={{ color: "#444", marginBottom: "5px" }}>
                Rp {item.jumlah.toLocaleString()}
              </div>

              {/* TAMPILKAN TANGGAL LUNAS JIKA ADA */}
              {item.status === "LUNAS" && (
                <div
                  style={{
                    fontSize: "12px",
                    color: "#2E7D32",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <Calendar size={12} /> Dibayar:{" "}
                  {formatTanggal(item.tanggal_bayar)}
                </div>
              )}
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <button
                onClick={() => toggleStatus(item)}
                style={{
                  background: item.status === "LUNAS" ? "#e8f5e9" : "#ffebee",
                  color: item.status === "LUNAS" ? "green" : "red",
                  border: "1px solid transparent",
                  padding: "6px 12px",
                  borderRadius: "20px",
                  cursor: "pointer",
                  fontSize: "12px",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                {item.status === "LUNAS" ? (
                  <>
                    <CheckCircle size={14} /> LUNAS
                  </>
                ) : (
                  <>
                    <XCircle size={14} /> BELUM
                  </>
                )}
              </button>

              <button
                onClick={() => handleDeleteTagihan(item.id)}
                style={{
                  background: "none",
                  border: "none",
                  color: "#ddd",
                  cursor: "pointer",
                }}
                title="Hapus"
              >
                <Trash2 size={16} />
              </button>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
